var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.iconClass)?_c('span',{class:("logo-symbol " + _vm.iconClass)}):_vm._e(),(!_vm.iconClass)?_c('span',{staticClass:"label label-default"},[_vm._v(_vm._s(_vm.appName))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }